/**
 * The type of the action which signals the keyboard shortcuts dialog should
 * be displayed.
 *
 * {
 *     type: OPEN_KEYBOARD_SHORTCUTS_DIALOG
 * }
 */
export const OPEN_KEYBOARD_SHORTCUTS_DIALOG
    = 'OPEN_KEYBOARD_SHORTCUTS_DIALOG';
